import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { usePlatform } from "@core-ui/hooks/usePlatform";

/** The web and desktop editors, where catalogs are edited; DocPortal and static sites only read them. */
export const useIsEditorApp = (): boolean => {
	const { isNext } = usePlatform();
	const isReadOnly = PageDataContextService.value?.conf?.isReadOnly;
	return !isNext && !isReadOnly;
};
